import { v5 as uuidv5 } from 'uuid';

const UUID_NAMESPACE = '022cfa5a-9c86-4e1a-8ed8-8d3435fd5bde';

export const NO_PREFERENCE_TEXT = 'No Preference';
export const NO_PREFERENCE_KEY = 'noPreference';

/**
 * A stable sentinel id, not a FloorPlan row — it matches nothing in the floor
 * plan list and must never be linked to.
 */
export const NO_PREFERENCE_UUID = uuidv5(NO_PREFERENCE_TEXT, UUID_NAMESPACE);

export const NO_PREFERENCE_OPTION = {
  value: NO_PREFERENCE_UUID,
  text: NO_PREFERENCE_TEXT,
  nBeds: NO_PREFERENCE_KEY,
};
